import { Pipe, PipeTransform } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { ACTIVITY_CATEGORY_NAME } from "@comunicare/comunicare-interfaces";

@Pipe({ name: "isProcedureActivity", pure: false }) // Need to set pure to false, otherwise the pipe is not triggered every time it is needed, not recommended to do this
export class IsProcedureActivityPipe implements PipeTransform {
  /**
   * Return weither the category of the activity works like the 'procedure' category or not
   */
  transform(activityForm: UntypedFormGroup): boolean {
    return [
      ACTIVITY_CATEGORY_NAME.APPOINTMENT,
      ACTIVITY_CATEGORY_NAME.TELECONSULTATION,
      ACTIVITY_CATEGORY_NAME.ENCOUNTER,
      ACTIVITY_CATEGORY_NAME.PROCEDURE, // has been replaced by "ENCOUNTER" but might still be present in DB
    ].includes(activityForm.get("detail").get("category").value);
  }
}
